import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
  /** Where on the page this button lives — sent to the Meta Pixel. */
  location?: string;
};
export function CtaButton({
  children,
  size = 'md',
  className = '',
  href = CHECKOUT_URL,
  location = 'landing'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-5 text-base sm:text-lg' : 'px-7 py-4 text-sm sm:text-base';
  const isCheckout = href === CHECKOUT_URL;
  const handleClick = () => {
    if (!isCheckout) return;
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Megapack Running',
      content_category: location,
      value: 23999,
      currency: 'ARS'
    });
  };
  return <a href={href} onClick={handleClick} {...isCheckout ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-sunset font-semibold uppercase tracking-wide text-white shadow-lg shadow-sunset/25 transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-sunset-dark hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sunset-dark active:translate-y-0 ${sizing} ${className}`} data-id="element-44" data-mp="159zue0ko70b2">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-45" data-mp="3swapknt25n8l" />
    </a>;
}